module.exports = __webpack_public_path__ + "jo.svg?08757ce23b147a6e6e7ef49b6d2ee29d";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/jo.svg
// module id = 846
// module chunks = 27